// extracted by mini-css-extract-plugin
export default {"avatar":"PersonAvatar__avatar___CQmnr","transparent":"PersonAvatar__transparent___eyO48","bordered":"PersonAvatar__bordered___suUdz","adult":"PersonAvatar__adult___OG_fM"};